import React, { FC, memo } from 'react';
import { CoreTheme as theme } from '@minecraft.themes';
import { useTranslation } from '@blocs.i18n';
import {
  FilterOverlayButtonContainer,
  StyledFilterOverlayButton,
  FilterOverlayButtonLabel,
  FilterIcon,
  ArrowIcon,
  HintText,
  StyledFiltersAplliedIndicator,
} from './FilterOverlayButtonStyles';

type Props = {
  areFiltersApplied?: boolean;
  isFilterOverlayOpened: boolean;
  isFilterOverlayFormDirty: boolean;
  toggleFilterOverlay: () => void;
};

const FilterOverlayButton: FC<Props> = ({
  areFiltersApplied,
  isFilterOverlayOpened,
  isFilterOverlayFormDirty,
  toggleFilterOverlay,
}) => {
  const { t } = useTranslation();
  return (
    <FilterOverlayButtonContainer>
      <StyledFilterOverlayButton $isOpened={isFilterOverlayOpened} onClick={toggleFilterOverlay}>
        <FilterIcon name="filter" alt="Filter" color={theme.colors.primary.white} />
        <FilterOverlayButtonLabel>{t('common:button.filter')}</FilterOverlayButtonLabel>
        <ArrowIcon name="caret-1" color={theme.colors.primary.white} />
      </StyledFilterOverlayButton>
      {areFiltersApplied && <StyledFiltersAplliedIndicator />}
      {isFilterOverlayFormDirty && <HintText>{t('common:filter.hintText')}</HintText>}
    </FilterOverlayButtonContainer>
  );
};

export default memo(FilterOverlayButton);
